import { cn } from '@/lib/utils'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/store/auth'
import { user_role } from '@/entities/user'
import { Download, Eye, Pencil, Trash } from 'lucide-react'
import { useEffect, useState } from 'react'
import { AnamneseProps, formatted_anamnese_profile_types } from '@/entities/anamnese'
import { handleDownloadFile } from '@/utils/download-util'
import { useMediaQuery } from '@/hooks/use-media-query'

interface AnamnesisListProps {
  type: string
  data: AnamneseProps[]
  onCreate?: (id: string) => void
  onDelete?: (id: string) => void
  onView?: (id: string) => void
}
export function AnamnesisList({ type, data, onCreate, onDelete, onView }: AnamnesisListProps) {
  const { user } = useAuthStore()
  const [filteredData, setFilteredData] = useState<AnamneseProps[]>(data.filter(d => d.profileType == type))
  const isMdAndDown = useMediaQuery('(max-width:1123px)')

  useEffect(() => {
    setFilteredData(data.filter(d => d.profileType == type))
  }, [data, type])

  return (
    <div>
      {filteredData?.length > 0 ? (
        filteredData
          .filter(d => d.profileType == type)
          ?.map((item, index) => (
            <div key={index} className={cn('flex mx-w-50 items-center justify-between p-2 rounded-lg dark:border border-slate-300 dark:border-slate-600 hover:border-pink-200 transition-colors duration-200', index % 2 == 0 ? 'bg-gray-300/40' : 'bg-gray-100/40', isMdAndDown && 'flex-col gap-y-5 py-5')}>
              <div className="flex">
                <span className="min-h-3 min-w-5 h-6 w-6 flex items-center justify-center bg-secondary text-white rounded-full text-sm font-medium mr-2">{index + 1}</span>
                <span className="text-lg font-medium text-gray-900 dark:text-white">{item.title}</span>
              </div>
              <div className="flex gap-x-3 flex-wrap gap-y-2 justify-center">
                {(user?.role == user_role.ADMIN || user?.role == user_role.MODERATOR) && (
                  <>
                    <Button variant="outline" className="flex items-center rounded-2xl p-2 hover:bg-blue-500 text-blue-500 border-blue-500 dark:text-white text-sm font-medium" onClick={() => onCreate(item.ref)}>
                      Editar
                      <Pencil className="h-4 w-4 ml-1" />
                    </Button>
                    <Button variant="outline" className="flex items-center rounded-2xl p-2 hover:bg-destructive dark:text-white text-red-500 border-red-500 text-sm font-medium" onClick={() => onDelete(item.ref)}>
                      Remover
                      <Trash className="h-4 w-4 ml-1" />
                    </Button>
                  </>
                )}
                <Button variant="outline" className="flex items-center rounded-2xl p-2 hover:bg-secondary text-secondary border-secondary dark:text-white text-sm font-medium" onClick={() => onView(item.ref)}>
                  Ver
                  <Eye className="h-4 w-4 ml-1" />
                </Button>
                <Button className="flex items-center rounded-2xl p-2 bg-secondary/30 hover:bg-secondary/60 dark:text-white text-primary text-sm font-medium" onClick={() => handleDownloadFile(item.paths[0], item.title)} disabled={!item.paths[0]?.length}>
                  Baixar Modelo
                  <Download className="h-4 w-4 ml-1" />
                </Button>
              </div>
            </div>
          ))
      ) : (
        <div className="flex items-center justify-center h-full py-5">
          <p className="text-gray-500">
            Nenhum tipo de anamnese <span className="lowercase font-bold">{formatted_anamnese_profile_types[type as keyof typeof formatted_anamnese_profile_types]}</span> encontrado
          </p>
        </div>
      )}
    </div>
  )
}
